import { Text } from '@vouched.id/vault';
import React from 'react';
export const TinValidationCaption = () => {
    return React.createElement(Text, { style: { marginBottom: '15px' } }, "TIN");
};
